import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Box, Button, Checkbox } from "@mui/material";
import { Link, NavLink } from "react-router-dom";
import GlobalVar from "../config/globalVar";
import { DateConvert } from "../utils/dateConverter";
import { transactionClicked } from "../store/gloabalState";
import { useRecoilState } from "recoil";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { useNavigate } from "react-router-dom";
import { orgID } from "../store/gloabalState";
import EditIcon from '@mui/icons-material/Edit';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    padding: ".5rem",
    fontSize: 14,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 13,
    padding: ".5rem",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function TableLayout(props) {
  const [transactionId, setTransactionId] = useRecoilState(transactionClicked);
  let [page, setPage] = useState(props.pageNumber);
  const OrganizationID = useRecoilState(orgID);
  let navigate = useNavigate();

  const nextSetFunc = () => {
    let page = props.pageNumber + 1;
    if (props.requestedCount < props.totalCount) {
      let rcount = props.requestedCount + 10;
      props.setRequestedCount(rcount);
      props.setPageNumber(page);
      setPage(page);
      props.apiCall(page);
    }
  };

  const prevSetFunc = () => {
    let page = props.pageNumber;
    if (page !== 0) {
      let rcount = props.requestedCount - 10;
      props.setRequestedCount(rcount);
      page = props.pageNumber - 1;
      props.setPageNumber(page);
      setPage(page);
      props.apiCall(page);
    }
  };
  return (
    <Paper>
      <TableContainer component={Paper}>
        <Table
          sx={{ minWidth: 700, maxHeight: 200 }}
          aria-label="customized table"
        >
          <TableHead>
            <TableRow>
              {props?.type === "ongoing" &&
                GlobalVar.ongoingCol.map((col, i) => {
                  return (
                    <StyledTableCell key={i}>{col.colName}</StyledTableCell>
                  );
                })}
              {props?.type === "all" &&
                GlobalVar.allCol.map((col, i) => {
                  return (
                    <StyledTableCell key={i}>{col.colName}</StyledTableCell>
                  );
                })}
              {props?.type === "unassigned" &&
                GlobalVar.unassignedCol.map((col, i) => {
                  return (
                    <StyledTableCell key={i}>{col.colName}</StyledTableCell>
                  );
                })}
              {props?.type === "users" &&
                GlobalVar.userlist.map((col, i) => {
                  return (
                    <StyledTableCell key={i}>{col.colName}</StyledTableCell>
                  );
                })}
              {props?.type === "usersBankDetails" &&
                GlobalVar.userBankList.map((col, i) => {
                  return (
                    <StyledTableCell key={i}>{col.colName}</StyledTableCell>
                  );
                })}
              {props?.type === "usersAdBankDetails" &&
                GlobalVar.userAdBankList.map((col, i) => {
                  return (
                    <StyledTableCell key={i}>{col.colName}</StyledTableCell>
                  );
                })}
              {props?.type === "bankUsers" &&
                GlobalVar.bankUsers.map((col, i) => {
                  return (
                    <StyledTableCell key={i}>{col.colName}</StyledTableCell>
                  );
                })}
            </TableRow>
          </TableHead>
          <TableBody>
            {props?.type === "ongoing" &&
              props?.transactions?.map((trans) => (
                <StyledTableRow key={trans.transactionId}>
                  {props?.type === "ongoing" &&
                    GlobalVar.ongoingCol.map((col, i) => {
                      return col.colId === "transactionId" ? (
                        <StyledTableCell key={i} scope="row">
                          <Link
                            onClick={(e) =>
                              setTransactionId(trans.transactionId)
                            }
                            to={"/transactiondetail/" + trans.transactionId}
                          >
                            {trans.transactionId}
                          </Link>
                        </StyledTableCell>
                      ) : (
                        <StyledTableCell key={i} align="left">
                          {trans[col.colId]
                            ? col.colId.toLocaleLowerCase().includes("date")
                              ? DateConvert(trans[col.colId])
                              : trans[col.colId]
                            : "-"}
                        </StyledTableCell>
                      );
                    })}
                </StyledTableRow>
              ))}
            {props?.type === "all" &&
              props?.transactions?.map((trans) => (
                <StyledTableRow key={trans.transactionId}>
                  {props?.type === "all" &&
                    GlobalVar.allCol.map((col, i) => {
                      return col.colId === "transactionId" ? (
                        <StyledTableCell key={i} scope="row">
                          <Link
                            onClick={(e) =>
                              setTransactionId(trans.transactionId)
                            }
                            to={"/transactiondetail/" + trans.transactionId}
                          >
                            {trans.transactionId}
                          </Link>
                        </StyledTableCell>
                      ) : (
                        <StyledTableCell key={i} align="left">
                          {trans[col.colId]
                            ? col.colId.toLocaleLowerCase().includes("date")
                              ? DateConvert(trans[col.colId])
                              : trans[col.colId]
                            : "-"}
                        </StyledTableCell>
                      );
                    })}
                </StyledTableRow>
              ))}
            {props?.type === "unassigned" &&
              props?.transactions?.map((trans) => (
                <StyledTableRow key={trans.transactionId}>
                  {props?.type === "unassigned" &&
                    GlobalVar.unassignedCol.map((col, i) => {
                      return col.colId === "transactionId" ? (
                        <StyledTableCell key={i} scope="row">
                          <Link
                            onClick={(e) =>
                              setTransactionId(trans.transactionId)
                            }
                            to={"/transactiondetail/" + trans.transactionId}
                          >
                            {trans.transactionId}
                          </Link>
                        </StyledTableCell>
                      ) : (
                        <StyledTableCell key={i} align="left">
                          {trans[col.colId]
                            ? col.colId.toLocaleLowerCase().includes("date")
                              ? DateConvert(trans[col.colId])
                              : trans[col.colId]
                            : "-"}
                        </StyledTableCell>
                      );
                    })}
                </StyledTableRow>
              ))}
            {props?.type === "users" &&
              props?.transactions?.map((trans) => (
                <StyledTableRow key={trans.transactionId}>
                  {props?.type === "users" &&
                    GlobalVar.userlist.map((col, i) => {
                      if (col.colId === "isAuthorizer") {
                        return (
                          <StyledTableCell key={i} align="left">
                            {
                              <Checkbox
                                defaultChecked={
                                  trans[col.colId] ? trans[col.colId] : false
                                }
                                onChange={(e) =>
                                  props.changeAuthUserList(trans["id"])
                                }
                              />
                            }
                          </StyledTableCell>
                        );
                      }
                      return (
                        <StyledTableCell key={i} align="left">
                          {trans[col.colId] ? trans[col.colId] : "-"}
                        </StyledTableCell>
                      );
                    })}
                </StyledTableRow>
              ))}
            {props?.type === "usersBankDetails" &&
              props?.transactions?.map((trans) => (
                <StyledTableRow key={trans.id}>
                  {props?.type === "usersBankDetails" &&
                    GlobalVar.userBankList.map((col, i) => {
                      if (col.colId === "isPrimaryAccount") {
                        return (
                          <StyledTableCell key={i} align="left">
                            {
                              <Checkbox
                                disabled
                                defaultChecked={trans[col.colId]}
                              />
                            }
                          </StyledTableCell>
                        );
                      }
                      if (col.colId === "edit") {
                        return (
                          <StyledTableCell key={i}>
                            <Button
                              variant="outlined"
                              onClick={() =>
                                navigate(
                                  `/editBank/${OrganizationID[0]}/${trans[col.colKey]
                                  }`
                                )
                              }
                            >
                              Edit
                            </Button>
                          </StyledTableCell>
                        );
                      }
                      return (
                        <StyledTableCell key={i} align="left">
                          {trans[col.colId] ? trans[col.colId] : "-"}
                        </StyledTableCell>
                      );
                    })}
                </StyledTableRow>
              ))}
            {props?.type === "usersAdBankDetails" &&
              props?.transactions?.map((trans) => (
                <StyledTableRow key={trans.id}>
                  {props?.type === "usersAdBankDetails" &&
                    GlobalVar.userAdBankList.map((col, i) => {
                      if (col.colId === "isPrimaryAccount") {
                        return (
                          <StyledTableCell key={i} align="left">
                            {
                              <Checkbox
                                disabled
                                defaultChecked={trans[col.colId]}
                              />
                            }
                          </StyledTableCell>
                        );
                      }
                      if (col.colId === "edit") {
                        return (
                          <StyledTableCell key={i}>
                            <Button
                              variant="outlined"
                              onClick={() =>
                                navigate(
                                  `/editAdBank/${OrganizationID[0]}/${trans[col.colKey]
                                  }`
                                )
                              }
                            >
                              Edit
                            </Button>
                          </StyledTableCell>
                        );
                      }
                      return (
                        <StyledTableCell key={i} align="left">
                          {trans[col.colId] ? trans[col.colId] : "-"}
                        </StyledTableCell>
                      );
                    })}
                </StyledTableRow>
              ))}
              {props?.type === "bankUsers" &&
              props?.transactions?.map((trans) => (
                <StyledTableRow key={trans.id}>
                  {props?.type === "bankUsers" &&
                    GlobalVar.bankUsers.map((col, i) => {
                      if (col.colId === "actions") {
                        return (
                          <StyledTableCell key={i} align="left">
                            {
                              <NavLink to={`/editbankuser/${trans.bankId}/${trans.id}`}>
                                <EditIcon sx={{height:'16px'}} />
                              </NavLink>
                            }
                          </StyledTableCell>
                        );
                      }
                      return (
                        <StyledTableCell key={i} align="left">
                          {trans[col.colId] ? trans[col.colId] : "-"}
                        </StyledTableCell>
                      );
                    })}
                </StyledTableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      {props?.type !== "users" &&
        props?.type !== "usersBankDetails" &&
        props?.type !== "usersAdBankDetails" && (
          <Box sx={{ padding: ".5rem 1rem", textAlign: "right" }}>
            <Button
              disabled={page === 0 ? true : false}
              onClick={prevSetFunc}
              sx={{ padding: "10px", marginRight: "20px" }}
            >
              <ArrowBackIosNewIcon />
              Previous{" "}
            </Button>
            <Button
              disabled={props.requestedCount > props.totalCount ? true : false}
              onClick={nextSetFunc}
              sx={{ padding: "10px" }}
            >
              Next
              <ArrowForwardIosIcon />{" "}
            </Button>
          </Box>
        )}
    </Paper>
  );
}
